import Alpine from 'alpinejs';

// import slideshow from './components/slideshow.js'
import form from './components/form.js'
import cf7 from './components/cf7.js'
import scrollable from './components/scrollable.js'
import landingSlider from './components/landing-slider.js'
import reveal from './components/reveal.js'

// Alpine.data('slideshow', slideshow)
Alpine.data('form', form)
Alpine.data('cf7', cf7)
Alpine.data('scrollable', scrollable)
Alpine.data('landingSlider', landingSlider)

window.addEventListener('load', () => {
  reveal()
  Alpine.start()

  const loader = document.getElementById('page-loader')
  if (loader) {
    loader.classList.add('hide')
    loader.addEventListener('transitionend', () => loader.remove(), { once: true })
  }
})

window.addEventListener('scroll', () => {
  document.querySelector('.header');
  if (window.scrollY > 0) {
    document.querySelector('.header').classList.add('scrolled');
  } else {
    document.querySelector('.header').classList.remove('scrolled');
  }
})

window.addEventListener('wpcf7mailsent', (e) => {
  const block = e.target.closest('.form-block');
  block.querySelector('.form-block__success').style.display = null;
})